import {CartDrawer, extractSectionId, fetchCart} from "theme";
import { Drawer } from "theme";
import { animateSequence as animateSequence2 } from "vendor";

var _sectionId, _CartDrawer_instances, onBundleSection_fn, onCartChange_fn, onPageShow_fn, refreshCart_fn, replaceContent_fn;

class CustomCartDrawer extends Drawer {
    constructor() {
        super(...arguments);
        __privateAdd(this, _CartDrawer_instances);
        __privateAdd(this, _sectionId);
    }
    connectedCallback() {
        super.connectedCallback()
        __privateGet(this, _sectionId) ?? __privateSet(this, _sectionId, extractSectionId(this));
        document.addEventListener("cart:prepare-bundled-sections", __privateMethod(this, _CartDrawer_instances, onBundleSection_fn).bind(this), { signal: this.abortController.signal });
        document.addEventListener("cart:change", __privateMethod(this, _CartDrawer_instances, onCartChange_fn).bind(this), { signal: this.abortController.signal });
        document.addEventListener("cart:refresh", __privateMethod(this, _CartDrawer_instances, refreshCart_fn).bind(this), { signal: this.abortController.signal });
        window.addEventListener("pageshow", __privateMethod(this, _CartDrawer_instances, onPageShow_fn).bind(this), { signal: this.abortController.signal });
    }
    get initialFocus() {
        return false;
    }
    createEnterAnimationControls() {
        const contentTransform =
            this.openFrom === "top"
                ? ["translateY(calc(-1 * var(--transform-logical-flip) * 100%)", "translateY(0)"]
                : ["translateX(calc(-1 * var(--transform-logical-flip) * 100%)", "translateX(0)"];
        this.getShadowPartByName("content").style.marginInlineStart = this.openFrom === "right" ? "auto" : "0";
        return animateSequence2([
            [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.25, ease: "easeInOut" }],
            [
                this.getShadowPartByName("content"),
                { opacity: [0, 1], transform: contentTransform },
                { duration: 0.45, at: "-0.15", ease: [0.86, 0, 0.07, 1] },
            ],
        ]);
    }

    createLeaveAnimationControls() {
        const contentTransform =
            this.openFrom === "top"
                ? ["translateY(0)", "translateY(calc(-1 * var(--transform-logical-flip) * 100%)"]
                : ["translateX(0)", "translateX(calc(-1 * var(--transform-logical-flip) * 100%)"];
        return animateSequence2([
            [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.45, ease: "easeInOut" }],
            [
                this.getShadowPartByName("content"),
                { opacity: [1, 0], transform: contentTransform },
                { duration: 0.45, at: "<", ease: [0.86, 0, 0.07, 1] },
            ],
        ]);
    }
}


// METODOS QUE SE USAN EN THEME.JS Y SE NECESITAN PARA LA FUNCONALIDAD DEL CART DRAWER

_sectionId = new WeakMap();
_CartDrawer_instances = new WeakSet();
/**
 * This method is called when the cart is changing, and allow custom sections to order a "re-render"
 */
onBundleSection_fn = function (event) {
    event.detail.sections.add(__privateGet(this, _sectionId));
};
/**
 * When the cart changes, we need to re-render the cart drawer
 */
onCartChange_fn = function (event) {
    const html = new DOMParser().parseFromString(event.detail.cart["sections"][__privateGet(this, _sectionId)], "text/html"), itemCount = event.detail.cart["item_count"], newCartDrawer = document.createRange().createContextualFragment(html.querySelector("custom-cart-drawer").innerHTML);
    if (itemCount === 0) {
        this.replaceChildren(...newCartDrawer.children);
    } else {
        this.replaceChildren(...newCartDrawer.children);
    }
    __privateMethod(this, _CartDrawer_instances, replaceContent_fn).call(this, event.detail.cart["sections"][__privateGet(this, _sectionId)]);
    if (window.themeVariables.settings.cartType === "drawer" && !this.open && event.detail.baseEvent === "variant:add") {
        this.show();
    }
};
onPageShow_fn = async function (event) {
    if (!event.persisted) {
        return;
    }
    __privateMethod(this, _CartDrawer_instances, refreshCart_fn).call(this);
};
refreshCart_fn = async function () {
    __privateMethod(this, _CartDrawer_instances, replaceContent_fn).call(this, await (await fetch(`${Shopify.routes.root}?section_id=${__privateGet(this, _sectionId)}`)).text());
};
replaceContent_fn = async function (html) {
    const domElement = new DOMParser().parseFromString(html, "text/html"), newCartDrawer = document.createRange().createContextualFragment(domElement.querySelector("custom-cart-drawer").innerHTML), itemCount = (await fetchCart)["item_count"];
    if (itemCount === 0) {
        this.replaceChildren(...newCartDrawer.children);
    } else {
        this.replaceChildren(...newCartDrawer.children);
    }
    this.dispatchEvent(new CustomEvent("custom-cart-drawer:refreshed", { bubbles: true }));
};





if (!customElements.get("custom-cart-drawer")) {
    customElements.define("custom-cart-drawer", CustomCartDrawer);
}
